import { jsx as _jsx } from "react/jsx-runtime";
export function Card({ children, className = "" }) {
    return (_jsx("div", { className: [
            "rounded-[var(--radius-lg)] border border-[var(--color-border)] bg-[var(--color-card)] text-[var(--color-card-foreground)] shadow-sm",
            className,
        ].join(" "), children: children }));
}
export function CardHeader({ children, className = "" }) {
    return (_jsx("div", { className: ["flex flex-col space-y-1.5 p-6", className].join(" "), children: children }));
}
export function CardTitle({ children, className = "" }) {
    return (_jsx("h3", { className: [
            "text-lg font-semibold leading-none tracking-tight",
            className,
        ].join(" "), children: children }));
}
export function CardContent({ children, className = "" }) {
    return _jsx("div", { className: ["p-6 pt-0", className].join(" "), children: children });
}
